import cn from 'classnames'
import { useFormikContext } from 'formik'

import FormStatus from 'components/FormStatus'
import FormStatusBody from 'components/FormStatus/FormStatusBody'
import FormStatusHeader from 'components/FormStatus/FormStatusHeader'

const Status = () => {
  const { values, setFieldValue } = useFormikContext()

  const handleToggleCustomTenderStatus = () =>
    setFieldValue('active', true)

  const isActiveAccount = values?.active

  return (
    <FormStatus classNames="margin-bottom-base">
      <FormStatusHeader classNames="custom-tenders-status-header">
        <div className="content-header">Tender Status</div>
        <div className="content-wrapper -no-padding">
          <span
            className={cn('status-dot margin-right-xs', {
              '-active': isActiveAccount,
              '-inactive': !isActiveAccount,
            })}
          ></span>
          <span>{isActiveAccount ? 'Active' : 'Deactivated'}</span>
        </div>
      </FormStatusHeader>
      {!isActiveAccount && (
        <FormStatusBody>
          <button
            className="btn -outline -btn-background-white w-100"
            type="button"
            onClick={handleToggleCustomTenderStatus}
          >
            Reactivate Custom Tender
          </button>
        </FormStatusBody>
      )}
    </FormStatus>
  )
}

export default Status
